import { render, staticRenderFns } from "./FeeScheduleTable.vue?vue&type=template&id=b6fccd06&scoped=true"
import script from "./FeeScheduleTable.vue?vue&type=script&lang=js"
export * from "./FeeScheduleTable.vue?vue&type=script&lang=js"
import style0 from "./FeeScheduleTable.vue?vue&type=style&index=0&id=b6fccd06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fccd06",
  null
  
)

export default component.exports